export function getNowSeconds() {
  return Math.floor(Date.now() / 1000)
}
